import Vue from 'vue';
import 'normalize.css/normalize.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';
import '@/styles/index.scss';
import '@/theme/ivm/index.scss';
import App from './App';
import store from './store';
import router from './router';
import VueExcelXlsx from 'vue-excel-xlsx';
import '@/icons';
import '@/permission';
Vue.use(require('vue-moment'));
Vue.use(VueExcelXlsx);
Vue.use(ElementUI, { locale });
Vue.config.productionTip = false;
Vue.prototype.$baseUrl = process.env.VUE_API_BASE_URL;

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
